'use strict';
var _ = require('lodash');
var Backbone = require('backbone');
var PubSub = require('tscom-pubsub');
var template = require('../../templates/user.ejs');

module.exports = Backbone.View.extend({
    className: 'view-user',
    events: {
        'click .login': 'login',
        'click .profile': 'profile',
        'click .logout': 'logout',
        'click .facebook': 'facebookShare',
        'click .twitter' : 'twitterShare'
    },
    /**
     * Initialize User View
     */
    initialize: function (options) {
        _.bindAll(this, 'render');
        this.userModel = options.userModel;

        this.listenTo(this.model, 'change:language', this.render);
        this.listenTo(this.userModel, 'change:id', this.render);

        // limit tracking to once per method per render
        this.alreadyShared = {
            facebook: false,
            twitter: false
        };
    },
    /**
     * Render User View
     */
    render: function () {
        var cms = this.model.get('text');
        var shareConfig = cms.share_experience;

        var model = _.extend({},
            cms.views_user_header,
            {
                share: shareConfig,
                loggedIn: this.userModel.isConnected() || false
            });

        this.$el.html(template(model));
        return this;
    },
    /**
     * [login description]
     * @return {[type]} [description]
     */
    login: function() {
        PubSub.trigger('omniture:action','oneIdSignin');
        PubSub.trigger('launchLogin');
    },
    /**
     * [logout description]
     * @return {[type]} [description]
     */
    logout: function() {
        this.userModel.logout();
    },
    /**
     * [profile description]
     * @return {[type]} [description]
     */
    profile: function() {
        this.userModel.profile();
    },
    /**
     * [ facebookShare ]
     */
    facebookShare: function( e ){
        if( !this.alreadyShared.facebook ){
            PubSub.trigger( 'customEvent', e );
            PubSub.trigger('omniture:action','facebookShare','Facebook Share');
            this.alreadyShared.facebook = true;
        }

        // perform facebook share
        PubSub.trigger( 'fbShareExperience' );
    },
    /**
     * [ twitterShare ]
     */
    twitterShare: function( e ) {
        if( !this.alreadyShared.twitter ){
            PubSub.trigger( 'customEvent', e );
            PubSub.trigger('omniture:action','twitterShare','Twitter Share');
            this.alreadyShared.twitter = true;
        }

        // perform twitter share
        PubSub.trigger( 'twitterShareExperience' );
    }
});



// WEBPACK FOOTER //
// ./app/scripts/common/views/user.js